/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react'
import { FiSun, FiMoon, FiMonitor } from 'react-icons/fi'

const THEME_STORAGE_KEY = 'theme-preference'

// Allowed values for theme preference
// - 'system' (default): follow the OS preference and react to changes
// - 'light': force light mode
// - 'dark': force dark mode
function ThemeToggle() {
  const [themePreference, setThemePreference] = useState(() => {
    try {
      const stored = localStorage.getItem(THEME_STORAGE_KEY)
      return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : 'system'
    } catch (_) {
      return 'system'
    }
  })

  const mediaQuery = useMemo(() => window.matchMedia('(prefers-color-scheme: dark)'), [])
  const [systemPrefersDark, setSystemPrefersDark] = useState(() => mediaQuery.matches)

  // React to system preference changes when in system mode
  useEffect(() => {
    const handler = (e) => setSystemPrefersDark(e.matches)
    try {
      mediaQuery.addEventListener('change', handler)
      return () => mediaQuery.removeEventListener('change', handler)
    } catch (_) {
      // Safari < 14 fallback
      mediaQuery.addListener(handler)
      return () => mediaQuery.removeListener(handler)
    }
  }, [mediaQuery])

  // Apply theme to <html> element and persist preference
  useEffect(() => {
    const root = document.documentElement
    const shouldUseDark = themePreference === 'dark' || (themePreference === 'system' && systemPrefersDark)
    if (shouldUseDark) {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
    try {
      localStorage.setItem(THEME_STORAGE_KEY, themePreference)
    } catch (_) {
      // ignore storage errors
    }
  }, [themePreference, systemPrefersDark])

  const options = ['light', 'dark', 'system']
  const getIcon = (opt) => (opt === 'light' ? <FiSun className="text-lg" /> : opt === 'dark' ? <FiMoon className="text-lg" /> : <FiMonitor className="text-lg" />)
  const getLabel = (opt) => (opt === 'light' ? 'Light mode' : opt === 'dark' ? 'Dark mode' : 'Device theme (default)')
  const selectedIndex = options.indexOf(themePreference)

  const handleSelect = (opt) => {
    setThemePreference(opt)
  }

  return (
    <div className="select-none flex-shrink-0">
      <div className="relative flex p-1 rounded-full border shadow-md backdrop-blur bg-white/80 border-gray-200 dark:bg-slate-800/70 dark:border-slate-700">
        {/* Sliding indicator */}
        <div
          className="absolute top-1 left-1 h-8 w-8 rounded-full bg-gray-200 dark:bg-slate-700 transition-transform duration-200 ease-out"
          style={{ transform: `translateX(${selectedIndex * 100}%)` }}
          aria-hidden="true"
        />

        {/* Options */}
        {options.map((opt) => {
          const active = opt === themePreference
          return (
            <button
              key={opt}
              aria-label={getLabel(opt)}
              title={getLabel(opt)}
              aria-pressed={active}
              onClick={() => handleSelect(opt)}
              className={`relative z-10 h-8 w-8 flex items-center justify-center rounded-full transition-colors
                ${active ? 'text-gray-900 dark:text-white' : 'text-gray-600 hover:text-gray-900/90 dark:text-gray-200 dark:hover:text-white/90'}`}
            >
              {getIcon(opt)}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default ThemeToggle


